import { SipPlanMode } from '../../../api/types'
import {
  isSipPlansFetchFailed,
  isSipPlansLoading,
  useSipPlansContext
} from '../../SipPlansProvider'
import { PlansCategoryListSkeleton } from '../../../../lumpsum/plans-list/lumpsum-ui-components/PlansCategoryListSkeleton'
import { SipYourPlanBlurredBody } from './SipYourPlanBlurredBody'
import { YourPlanCategoryList } from './YourPlanCategoryList'
import { YourPlanPlansListErrorState } from './YourPlanPlansListErrorState'

/** Rolled-out Your Plan body: locked (not Prime) or full list. */
export function SipYourPlanBody() {
  const { plansOverview, plansQuery } = useSipPlansContext()

  if (isSipPlansLoading(SipPlanMode.YOUR_PLAN, plansQuery)) {
    return <PlansCategoryListSkeleton />
  }

  if (isSipPlansFetchFailed(SipPlanMode.YOUR_PLAN, plansQuery)) {
    return <YourPlanPlansListErrorState onRetry={plansQuery.refetch} />
  }

  if (plansOverview?.isPlanSubscriptionEligible !== true) {
    return <SipYourPlanBlurredBody />
  }

  return <YourPlanCategoryList />
}
